// consts/enums
import {
    SET_FIELD_ERROR,
    SET_ERROR_FIELDS,
    CLEAR_FIELD_ERROR,
    CLEAR_ENTITY_ERRORS,
    CLEAR_CATEGORY_ERRORS,
    SET_RECOMMENDED_FIELDS,
    SET_ERROR_FIELDS_BY_CATEGORY
} from '../actionTypes/dealScreenErrorActionTypes';
import type { FieldErrors } from '../reducers/dealScreenErrorReducer';

// Error handling action creators
export const setFieldError =
    (entity: string, field: string, error: boolean, ispaymentError?: boolean, skipAccumulation: boolean = false) =>
    (dispatch: any, _getState: any) => {
        return dispatch({
            type: SET_FIELD_ERROR,
            payload: { entity, field, error, ispaymentError, skipAccumulation }
        });
    };

export const setErrorFields =
    (entity: string, errorFields: Record<string, boolean> = {}, skipAccumulation: boolean = false) =>
    (dispatch: any) => {
        return dispatch({
            type: SET_ERROR_FIELDS,
            payload: { entity, errorFields, skipAccumulation }
        });
    };

export const clearEntityErrors = (entity: string) => ({
    type: CLEAR_ENTITY_ERRORS,
    payload: { entity }
});

export const clearCategoryErrors = (entity: string, category: string) => ({
    type: CLEAR_CATEGORY_ERRORS,
    payload: { entity, category }
});

export const setRecommendedFields = (entity: string, recommendedFields: Record<string, boolean>) => ({
    type: SET_RECOMMENDED_FIELDS,
    payload: { entity, recommendedFields }
});

export const clearFieldError = (field: string) => ({
    type: CLEAR_FIELD_ERROR,
    payload: { field }
});

export const clearRecommendations = (entity: string) => ({
    type: CLEAR_FIELD_ERROR,
    payload: { entity }
});

export const setErrorFieldsByCategory = (
    entity: string,
    category: string,
    categoryErrors: Array<FieldErrors>,
    skipCategoryMerge: boolean = false,
    deleteIndex: number = -1,
    skipAccumulation: boolean = false
) => ({
    type: SET_ERROR_FIELDS_BY_CATEGORY,
    payload: { entity, category, categoryErrors, skipCategoryMerge, deleteIndex, skipAccumulation }
});
